import FILES_ACTION from '../../constants/action'
import FILES_PATH from '../../constants/path'
import isConnectedNetworkSelect from '../../../network/selectors/is-connected'
import setReduxAction from '../../../redux/actions/set'
import { getActionStrReduxUtil } from '../../../redux/utils/get-action-str'
import {
  differenceInHoursDateUtil,
  getObjectUtil,
  logUtil
  , pickObjectUtil
} from 'packages/src'
import deleteFileSystemUtil from '../../../../utils/file-system/delete'
import setUtil from '../../../../utils/set'

const UNLOAD_LAST_USED_AT_DIFF_HOURS = 8

// const DELETE_UNUSED_FILES_COUNT_DIVIDER = 3

export async function deleteFileUtil (state, uri) {
  const filesData = {
    ...(
      getObjectUtil(state, FILES_PATH.DATA) || {}
    )
  }

  const item = filesData[uri]
  if (!item) {
    logUtil('deleteFileUtil')
      .debug(`[noop] uri ${uri} not found`)
    return filesData
  }

  logUtil('deleteFileUtil')
    .debug(`[delete] uri ${uri}`)
  await deleteFileSystemUtil(uri, { idempotent: true })
  delete filesData[uri]
  // await runAfterDelayPromisifiedPerformanceUtil()
  return filesData
}

export function deleteFileAction (uri) {
  return async (dispatch, getState) => {
    const filesData = await deleteFileUtil(getState(), uri)
    dispatch(setReduxAction({
      type: getActionStrReduxUtil(FILES_ACTION.DELETE_ITEM, uri),
      payload: {
        path: FILES_PATH.DATA,
        value: filesData
      }
    }))
  }
}

// function getPathFromUri (uri, separator = '/') {
//   if (typeof uri !== 'string') {
//     uri = uri + ''
//   }
//   if (!uri.includes(separator)) {
//     return
//   }
//   const [domainName, id] = uri.split(separator)
//   return `${domainName}.${REDUX_DOMAIN_LIST_KEY.ALL}.${id}`
// }

export function deleteUnusedFilesUtil (filesData) {
  return async (dispatch, getState) => {
    let uris = Object.keys(filesData)
    const urisCount = uris.length
    logUtil('deleteUnusedFilesUtil')
      .debug(`length ${uris.length}`)
    if (!uris.length) {
      logUtil('deleteUnusedFilesUtil')
        .debug('[noop]')
      return getState()
    }
    const urisCountToRemove = urisCount / 3
    logUtil('deleteUnusedFilesUtil')
      .debug(`urisCountToRemove ${urisCountToRemove}`)
    uris = uris.slice(0, urisCountToRemove)
    logUtil('deleteUnusedFilesUtil')
      .debug(`[start] length ${uris.length}`)
    const deleteAllFiles = () => {
      return new Promise(resolve => {
        if (!uris.length) {
          logUtil('deleteUnusedFilesUtil')
            .debug('[done]')
          const newState = setUtil(getState(), FILES_PATH.DATA, filesData)
          return resolve(getObjectUtil(newState, FILES_PATH.DATA))
        }
        const uri = uris.pop()
        const lastUsedAt = filesData[uri]
        const lastUsedAtDate = new Date(lastUsedAt)
        if (lastUsedAtDate &&
          differenceInHoursDateUtil(new Date(), lastUsedAtDate) <
          UNLOAD_LAST_USED_AT_DIFF_HOURS) {
          logUtil('deleteUnusedFilesUtil')
            .debug('[noop]: ', uri)
          return resolve(deleteAllFiles())
        }
        logUtil('deleteUnusedFilesUtil')
          .debug('[delete]: ', uri)
        return resolve(deleteFileUtil(getState(), uri))
          .then(deleteAllFiles)
      })
    }
    return deleteAllFiles()
  }
}

export function deleteUnusedFilesAction () {
  return async (dispatch, getState) => {
    if (!isConnectedNetworkSelect(getState())) {
      logUtil('deleteUnusedFilesUtil')
        .log('[noop] not connected')
      return
    }

    const data = (
      getObjectUtil(getState(), FILES_PATH.DATA) || {}
    )
    const keys = Object.keys(data)
    logUtil('deleteUnusedFilesAction')
      .debug('keys: ', keys)
    // const keysLengthToKeep = keys.length / DELETE_UNUSED_FILES_COUNT_DIVIDER
    // const keysLengthToKeep = keys.length
    // const keysToKeep = keys.slice(0, keysLengthToKeep)
    const keysToDelete = []
    const keysToKeep = keys.filter(key => {
      // Keep images
      const res = !key.includes('.mp4')
      if (!res) {
        keysToDelete.push(key)
      }
      return res
    })
    logUtil('keysToKeep')
      .debug('keysToKeep: ', keysToKeep)
    logUtil('deleteUnusedFilesAction')
      .debug('keysToDelete: ', keysToDelete)
    const filesData = pickObjectUtil(data, keysToKeep)
    const filesDataToDelete = pickObjectUtil(data, keysToDelete)
    const newState = await dispatch(deleteUnusedFilesUtil(filesDataToDelete))
    const newFilesData = {
      ...(
        getObjectUtil(newState, FILES_PATH.DATA) || {}
      ),
      ...filesData
    }
    dispatch(setReduxAction({
      type: FILES_ACTION.DELETE_UNUSED,
      payload: {
        path: FILES_PATH.DATA,
        value: newFilesData
      }
    }))
  }
}
